import { createSelector } from 'reselect';

export const getRegisterAccessor = state => state.auth.register;
export const getSinginAccessor = state => state.signin;
export const getLogInAccessor = state => state.auth.login;

export const signinSelector = createSelector(getSinginAccessor, signin => signin);
export const registerSelector = createSelector(getRegisterAccessor, state => state);
export const logInSelector = createSelector(getLogInAccessor, logIn => logIn);